import axios from 'axios'
import { getResponseData } from 'src/queries/network.utils'
import { NotificationSettingsResponse } from 'src/queries/notificationSettings/notificationSettings.models'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'
import { PatchNotificationSettingsRequest } from 'src/requests/patchNotificationSettings.request'

export const getNotificationSettings =
  async (): Promise<NotificationSettingsResponse> => {
    return getResponseData(
      axios.get<NotificationSettingsResponse>(
        '/notificationsettings',
        getRequestConfig(RequestConfig.Default),
      ),
    )
  }

export const patchNotificationSettings = async (
  body: PatchNotificationSettingsRequest,
): Promise<NotificationSettingsResponse> => {
  // The trailing slash matches the legacy thunk's PATCH URL exactly.
  return getResponseData(
    axios.patch<NotificationSettingsResponse>(
      '/notificationsettings/',
      body,
      getRequestConfig(RequestConfig.Default),
    ),
  )
}
